<div id="ancre-conseils" class="home-actus py-3 py-md-5">
  <div class="container">
    <h3 class="fw-normal text-bleu-tdm text-uppercase">ACTUALITÉS IMMO</h3>
    <p>Retrouvez tous nos derniers articles et plongez dans votre projet immobilier avec sérénité.</p>

    <div class="actus-list row row-cols-md-3 row-cols-sm-1">
      <ng-container *ngIf="articlesList && articlesList.length > 0">
        <div *ngFor="let article of articlesList">
          <app-card-article [article]="article"></app-card-article>
        </div>
      </ng-container>
    </div>
    <div class="mb-4 mb-md-5 mt-2 mt-md-3">
      <a [routerLink]="['/blog']"  class="btn btn-primary text-white">Voir plus d’articles</a>
    </div>
  </div>
</div>
